const questions = [
    {
        id: 1,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "Я не чувствую себя расстроенным(ой), печальным(ой)", score: 0 },
            { id: 2, answer: "Я расстроен(а)", score: 1 },
            { id: 3, answer: "Я все время расстроен(а) и не могу от этого отключиться", score: 2 },
            { id: 4, answer: "Я настолько расстроен(а) и несчастлив(а), что не могу это выдержать", score: 3 },
        ],
    },
    {
        id: 2,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "Я не тревожусь о своем будущем", score: 0 },
            { id: 2, answer: "Я чувствую, что озадачен(а) будущим", score: 1 },
            { id: 3, answer: "Я чувствую, что меня ничего не ждет в будущем", score: 2 },
            { id: 4, answer: "Мое будущее безнадежно, и ничто не может измениться к лучшему", score: 3 },
        ],
    },
    {
        id: 3,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "Я не чувствую себя неудачником(цей)", score: 0 },
            { id: 2, answer: "Я чувствую, что терпел(а) больше неудач, чем другие люди", score: 1 },
            { id: 3, answer: "Когда я оглядываюсь на свою жизнь, я вижу в ней много неудач", score: 2 },
            { id: 4, answer: "Я чувствую, что как личность я — полный(ая) неудачник(ца)", score: 3 },
        ],
    },
    {
        id: 4,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "Я получаю столько же удовлетворения от жизни, как раньше", score: 0 },
            { id: 2, answer: "Я не получаю столько же удовлетворения от жизни, как раньше", score: 1 },
            { id: 3, answer: "Я больше не получаю удовлетворения ни от чего", score: 2 },
            { id: 4, answer: "Я полностью не удовлетворен(а) жизнью, и мне все надоело", score: 3 },
        ],
    },
    {
        id: 5,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "Я не чувствую себя в чем-нибудь виноватым(ой)", score: 0 },
            { id: 2, answer: "Достаточно часто я чувствую себя виноватым(ой)", score: 1 },
            { id: 3, answer: "Большую часть времени я чувствую себя виноватым(ой)", score: 2 },
            { id: 4, answer: "Я постоянно испытываю чувство вины", score: 3 },
        ],
    },
    {
        id: 6,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "Я не чувствую, что могу быть наказанным(ой) за что-либо", score: 0 },
            { id: 2, answer: "Я чувствую, что могу быть наказан(а)", score: 1 },
            { id: 3, answer: "Я ожидаю, что могу быть наказан(а)", score: 2 },
            { id: 4, answer: "Я чувствую себя уже наказанным(ой)", score: 3 },
        ],
    },
    {
        id: 7,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "Я не разочаровался(ась) в себе", score: 0 },
            { id: 2, answer: "Я разочаровался(ась) в себе", score: 1 },
            { id: 3, answer: "Я себе противен(а)", score: 2 },
            { id: 4, answer: "Я себя ненавижу", score: 3 },
        ],
    },
    {
        id: 8,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "Я знаю, что я не хуже других", score: 0 },
            { id: 2, answer: "Я критикую себя за ошибки и слабости", score: 1 },
            { id: 3, answer: "Я все время обвиняю себя за свои поступки", score: 2 },
            { id: 4, answer: "Я виню себя во всем плохом, что происходит", score: 3 },
        ],
    },
    {
        id: 9,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "Я никогда не думал(а) покончить с собой", score: 0 },
            { id: 2, answer: "Ко мне приходят мысли покончить с собой, но я не буду их осуществлять", score: 1 },
            { id: 3, answer: "Я хотел(а) бы покончить с собой", score: 2 },
            { id: 4, answer: "Я бы убил(а) себя, если бы представился случай", score: 3 },
        ],
    },
    {
        id: 10,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "Я плачу не больше, чем обычно", score: 0 },
            { id: 2, answer: "Сейчас я плачу чаще, чем раньше", score: 1 },
            { id: 3, answer: "Теперь я все время плачу", score: 2 },
            { id: 4, answer: "Раньше я мог(ла) плакать, а сейчас не могу, даже если мне хочется", score: 3 },
        ],
    },
    {
        id: 11,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "Сейчас я раздражителен(льна) не более, чем обычно", score: 0 },
            { id: 2, answer: "Я более легко раздражаюсь, чем раньше", score: 1 },
            { id: 3, answer: "Теперь я постоянно чувствую, что раздражен(а)", score: 2 },
            { id: 4, answer: "Я стал(а) равнодушен(на) к вещам, которые меня раньше раздражали", score: 3 },
        ],
    },
    {
        id: 12,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "Я не утратил(а) интереса к другим людям", score: 0 },
            { id: 2, answer: "Я меньше, чем раньше, интересуюсь другими людьми", score: 1 },
            { id: 3, answer: "Я почти потерял(а) интерес к другим людям", score: 2 },
            { id: 4, answer: "Я полностью утратил(а) интерес к другим людям", score: 3 },
        ],
    },
    {
        id: 13,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "Я откладываю принятие решения иногда, как и раньше", score: 0 },
            { id: 2, answer: "Я чаще, чем раньше, откладываю принятие решения", score: 1 },
            { id: 3, answer: "Мне труднее принимать решения, чем раньше", score: 2 },
            { id: 4, answer: "Я больше не могу принимать решения", score: 3 },
        ],
    },
    {
        id: 14,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "Я не чувствую, что выгляжу хуже, чем обычно", score: 0 },
            { id: 2, answer: "Меня тревожит, что я выгляжу старым(ой) и непривлекательным(ой)", score: 1 },
            { id: 3, answer: "Я знаю, что в моей внешности произошли существенные изменения, делающие меня непривлекательным(ой)", score: 2 },
            { id: 4, answer: "Я знаю, что выгляжу безобразно", score: 3 },
        ],
    },
    {
        id: 15,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "Я могу работать так же хорошо, как и раньше", score: 0 },
            { id: 2, answer: "Мне необходимо сделать дополнительное усилие, чтобы начать делать что-нибудь", score: 1 },
            { id: 3, answer: "Я с трудом заставляю себя делать что-либо", score: 2 },
            { id: 4, answer: "Я совсем не могу выполнять никакую работу", score: 3 },
        ],
    },
    {
        id: 16,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "Я сплю так же хорошо, как и раньше", score: 0 },
            { id: 2, answer: "Сейчас я сплю хуже, чем раньше", score: 1 },
            { id: 3, answer: "Я просыпаюсь на 1–2 часа раньше, и мне трудно заснуть опять", score: 2 },
            { id: 4, answer: "Я просыпаюсь на несколько часов раньше обычного и больше не могу заснуть", score: 3 },
        ],
    },
    {
        id: 17,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "Я устаю не больше, чем обычно", score: 0 },
            { id: 2, answer: "Теперь я устаю быстрее, чем раньше", score: 1 },
            { id: 3, answer: "Я устаю почти от всего, что я делаю", score: 2 },
            { id: 4, answer: "Я не могу ничего делать из-за усталости", score: 3 },
        ],
    },
    {
        id: 18,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "Мой аппетит не хуже, чем обычно", score: 0 },
            { id: 2, answer: "Мой аппетит стал хуже, чем раньше", score: 1 },
            { id: 3, answer: "Мой аппетит теперь значительно хуже", score: 2 },
            { id: 4, answer: "У меня вообще нет аппетита", score: 3 },
        ],
    },
    {
        id: 19,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "В последнее время я не похудел(а) или потеря веса была незначительной", score: 0 },
            { id: 2, answer: "За последнее время я потерял(а) более 2 кг", score: 1 },
            { id: 3, answer: "Я потерял(а) более 5 кг", score: 2 },
            { id: 4, answer: "Я потерял(а) более 7 кг", score: 3 },
        ],
    },
    {
        id: 20,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "Я беспокоюсь о своем здоровье не больше, чем обычно", score: 0 },
            { id: 2, answer: "Меня тревожат проблемы моего физического здоровья, такие, как боли, расстройство желудка, запоры и т.д.", score: 1 },
            { id: 3, answer: "Я очень обеспокоен(а) своим физическим состоянием, и мне трудно думать о чем-либо другом", score: 2 },
            { id: 4, answer: "Я настолько обеспокоен(а) своим физическим состоянием, что больше ни о чем не могу думать", score: 3 },
        ],
    },
    {
        id: 21,
        question: "Определите утверждение, которое лучше всего соответствует тому, как вы себя чувствовали на этой неделе и сегодня.",
        answers: [
            { id: 1, answer: "В последнее время я не замечал(а) изменения своего интереса к сексу", score: 0 },
            { id: 2, answer: "Меня меньше занимают проблемы секса, чем раньше", score: 1 },
            { id: 3, answer: "Сейчас я значительно меньше интересуюсь сексуальными проблемами, чем раньше", score: 2 },
            { id: 4, answer: "Я полностью утратил(а) сексуальный интерес", score: 3 },
        ],
    },
];

export default questions;